import { render } from "./ViewSupportRequest.vue?vue&type=template&id=24994fee&scoped=true"
import script from "./ViewSupportRequest.vue?vue&type=script&lang=js"
export * from "./ViewSupportRequest.vue?vue&type=script&lang=js"

import "vue-multiselect/dist/vue-multiselect.css?vue&type=style&index=0&lang=css"
import "./ViewSupportRequest.vue?vue&type=style&index=1&id=24994fee&scoped=true&lang=scss"

import exportComponent from "/var/www/html/lynkto-vlan-ticket-admin-panel/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-24994fee"]])

export default __exports__